<template>
  <div>

  <header>
            <Header
        :HideCart='true'
        Title='Pedido enviado'
        class="mb-5" 
        />
  </header>

  <section style="max-height:99vh">


    <form class='register'>



      <CenteredFigure
      class='centered'
      :Img='InviteFriend'
      />

      <TitleH3
      class='titleh1 '
      Text='INDIQUE PARA UM AMIGO E GANHE R$5,00 DE CRÉDITO'
      />

      <InputRedLight
          class="inputWhatsapp" 
          autoComplete="off"
          placeholder='Insira um número de whatsapp'
          id="whatsapp"
          type="tel"
          minLength=11
          maxLength=50
          title="Digite um whatsapp"

       />
  
<FooterContainer>


        
        <Button
        id='first_button'
        Type='submit'
        Text='ACOMPANHAR PEDIDO'
        :ButtonFunction='next_step'
        />



</FooterContainer>

    </form>

  </section>
  </div> 
</template>

<script>

import Header from '../../components/Header/Header'
import InviteFriend from '../../assets/img/invite_friend.svg'
import CenteredFigure from '../../components/ImageStyle/CenteredFigure'
import TitleH3 from '../../components/Title/TitleH3'
import Button from '../../components/Button/ButtonCallToAction'
import FooterContainer from '../../components/Container/FooterContainer'
import InputRedLight from '../../components/Input/InputRedLight'

export default {
  components: {

    Header,
    TitleH3,
    CenteredFigure,
    FooterContainer,
    Button,
    InputRedLight,
  },
  data() {
    return {
      InviteFriend: InviteFriend,
      form: {
        nome: '',
        email: '',
        celular: '',
      }
    }
  },
  methods: {
    next_step() {
      console.log('next step', this.form.nome, this.form.email,this.form.celular)
    }
  },
}
</script>

<style scoped lang="css">



.titleh1{
  display: flex;
  align-items: center;
  text-align: center;
}

.inputWhatsapp{
  margin-top:7.25rem;
}

#first_button{
  margin-bottom:.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:6.25rem;  
}

  @media (min-width: 1400px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
